/* ==========================================================================
   Modals + Nutritional Info Image (supports full CDN URLs or filenames)
   ========================================================================== */

(function ($) {
  "use strict";

  function normaliseUrl(url) {
    if (!url) return "";
    url = String(url).trim();

    // Protocol-relative -> https://...
    if (url.indexOf("//") === 0) {
      url = window.location.protocol + url;
    }

    return url;
  }

  function isAbsoluteUrl(url) {
    return /^https?:\/\//i.test(url);
  }

  function updateNutritionalInfoImage(infoImage) {
    var $img = $(".nutritional-info__img");
    if (!$img.length) return;

    var info = normaliseUrl(infoImage);
    if (!info) return;

    // If we received a full URL (Shopify image_url output), use it directly.
    if (isAbsoluteUrl(info)) {
      $img.attr("src", info);
      return;
    }

    // Otherwise treat it as a filename and keep the legacy behaviour:
    // build a new file path relative to the current image's directory.
    var imgUrl = normaliseUrl($img.attr("src") || "");
    if (!imgUrl) {
      // No existing src to derive from, fall back to using the value as-is.
      $img.attr("src", info);
      return;
    }

    var basePath = imgUrl.substring(0, imgUrl.lastIndexOf("/") + 1);
    var newImgFile = basePath + info;

    $img.attr("src", newImgFile);
  }

  function launchModal(params) {
    var modalId = params && params.modal ? params.modal : "";
    if (!modalId) return;

    var $modal = $("#" + modalId);
    if (!$modal.length) return;

    $modal.addClass("active");
    $(".modal-mask").addClass("active");
    $("body").addClass("modal-active");

    if (modalId === "nutritional-modal") {
      updateNutritionalInfoImage(params.infoImage);
    }
  }

  function dismissModal() {
    $(".modal.active").removeClass("active");
    $(".modal-mask").removeClass("active");
    $("body").removeClass("modal-active");
  }

  // Open modal
  $(document).on("click", "a.modal-trigger", function (ev) {
    ev.preventDefault();
    launchModal(this.dataset || {});
  });

  // Close modal (your existing selector)
  $(document).on("click", 'a[data-dismiss="modal"]', function (ev) {
    ev.preventDefault();
    dismissModal();
  });

})(jQuery);
